<template>
    <CRow>
        <CCol col>
            <div id="marketMain">
                <div class="market-price-padding"></div>
                <ejs-datepicker ref="dateObj" :placeholder="waterMark" v-model="dateVal" :format="dateFormat" :focus='onFocus' :firstDayOfWeek='1' :max='maxVal' width=180></ejs-datepicker>
                <div style="width:100%; height: 80vh;">
                    <ejs-grid ref='grid' :dataSource="marketPricingData" :allowFiltering='true' :allowPaging="true"
                              :allowResizing='true' :toolbarClick='toolbarClick' :allowExcelExport='true'
                              :excelExportComplete='excelExportComplete' :allowReordering='true' :allowSorting='true'
                              :editSettings='editSettings' :toolbar='toolbar' :pageSettings='pageSettings' :actionBegin='actionBegin'
                              :actionComplete='actionComplete' :actionFailure="actionFailure" :query='query' :filterSettings='filterOptions' width="100%" height="100%">
                        <e-columns>
                            <e-column field='id' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                            <e-column field='year' headerText='Year' textAlign='Left' :validationRules='yearRules' editType='numericedit' :edit='yearParams' width=120 type="number"></e-column>
                            <e-column field='period' headerText='Period Indicator' textAlign='Left' foreignKeyField="periodId" :visible="false" :validationRules="requiredRules" foreignKeyValue='name' :dataSource='periods' editType='dropdownedit' :edit='periodIndicatorParams' width=180></e-column>
                            <e-column field='periodName' headerText='Period Indicator' textAlign='Left' width=180 type="string"></e-column>
                            <e-column field='periodSpan' ref="dpPeriod" headerText='Period' textAlign='Left' foreignKeyField="periodSpanId" :visible="false" :validationRules="periodSpanRequiredRules" foreignKeyValue='name' :dataSource='periodSpans' editType='dropdownedit' :edit='periodParams' width=150></e-column>
                            <e-column field='periodSpanName' headerText='Period' textAlign='Left' width=150 type="string"></e-column>
                            <e-column field='ricId' headerText='Identifier' textAlign='Left' :validationRules="requiredRules" :visible="false" editType='dropdownedit' :edit='ricParams' foreignKeyField="id" foreignKeyValue='fullRic' :dataSource='rics' width=130></e-column>
                            <e-column field='fullRicName' headerText='Identifier' textAlign='Left' visible="true" width=150 type="string"></e-column>
                            <e-column field='stateName' headerText='Country' textAlign='Left' :allowEditing="false" width=150 type="string"></e-column>
                            <e-column field='priceAreaName' headerText='Price Area' textAlign='Left' width=130 :allowEditing="false" type="string"></e-column>
                            <e-column field='date' headerText='Report Date' textAlign='Left' :allowEditing="true" :visible='true' width=150 :format='dateFormatOptions' type='date'></e-column>
                            <e-column field='universalClosePriceDate' headerText='Settlement Date' textAlign='Left' :validationRules="requiredRules" :format='dateFormatOptions' type='date' :edit="dpParams" width=180></e-column>
                            <e-column field='price' headerText='Settlement Price' textAlign='Left' :validationRules="percentageRules" type="number" format="n3" editType='numericedit' :edit='numericParams' width=180></e-column>
                            <e-column field='tradingUnitPreview' headerText='Trading Unit' textAlign='Left' :allowEditing="false" width=150 type="string"></e-column>
                            <e-column field='createdBy' headerText='Created By' textAlign='Left' :allowEditing="false" width=190 type="string"></e-column>
                            <e-column field='createdDate' headerText='Import Date' textAlign='Left' :allowEditing="false" :format='dateFormatOptions' type='date' width=150></e-column>
                            <!--<e-column field='date' headerText='Date' textAlign='Left' :allowEditing="false" :visible='false' width=150></e-column>-->
                        </e-columns>
                    </ejs-grid>
                </div>
                <div id="modalTarget" class="control-section; position:relative" style="height:350px;">
                    <ejs-uploader ref="uploadObj" id='defaultfileupload' name="uploadFile" :allowedExtensions="extensions" :uploading="addHeaders" :asyncSettings="path" :success="onUploadSuccess" :failure="onUploadFailed" :multiple='multiple'></ejs-uploader>
                </div>
                </div>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import authToken from '../../common/authToken';
    import urls from '../../common/urls'
    import SyncHelper from '../../common/syncfusion';
    import gridOptions from '../../common/gridOptions'
    import dates from '../../common/dates'
    import apis from '../../common/network'
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import store from '../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(DatePickerPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(GridPlugin);
    let periodIndicatorElem, periodParamElem, periodIndicatorObj, periodSpanObj, ricObj, ricElem, datePickerObj, elem;
    export default {
        components: {
        },
        data() {
            return {
                store: store,
                maxVal: new Date(),
                waterMark: 'Select a date',
                dateVal: dates.addDays(new Date(),-1),
                format: "dd/MM/yyyy",
                dateFormat: 'dd/MM/yyyy',
                rics: SyncHelper.getDataManager('Utils/rics'),
                periodSpans: SyncHelper.getDataManager('Utils/periodSpans'),
                periods: SyncHelper.getDataManager('Utils/marketPeriods'),
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } },
                numericParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 4,
                        format: "n4"
                    }
                },
                yearParams: {
                    params: {
                        validateDecimalOnType: true,
                        decimals: 0,
                        format: "####"
                    }
                },
                path: {
                    saveUrl: `${urls.apiBaseUrl}MarketPricingPerDay/Import/`
                },
                extensions: ' .xls, .xlsx',
                multiple: false,
                marketPricingData: this.$store.state.permissions["Permissions.LatestSettlement.View"] ? SyncHelper.getDataManager("MarketPricingPerDay") : [],
                dpParams: {
                    create: function () {
                        elem = document.createElement('input');
                        return elem;
                    },
                    read: () => {
                        return datePickerObj.value;
                    },
                    destroy: () => {
                        datePickerObj.destroy();
                    },
                    write: (args) => {
                        datePickerObj = new DatePicker({
                            value: new Date(args.rowData[args.column.field]),
                            floatLabelType: 'Always',
                            format: 'dd/MM/yyyy',
                            //sets the max. 
                            max: dates.addDays(new Date(), -1),
                            placeholder: 'Settlement Date',
                            firstDayOfWeek: 1
                        });
                        datePickerObj.appendTo(elem);
                    }
                }, 
                ricParams: {
                    create: () => {
                        ricElem = document.createElement('input');
                        return ricElem;
                    },
                    read: () => {
                        return ricObj.value;
                    },
                    destroy: () => {
                        ricObj.destroy();
                    },
                    write: (args) => {
                        ricObj = new DropDownList({
                            dataSource: this.rics,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            allowFiltering: true,
                            showClearButton: true,
                            change: (args) => {
                                apis.protectedApi(`${urls.apiBaseUrl}Utils/rics`).then(it => {
                                      var mappedRic = it.data.filter(function (ric) {
                                        return ric.id == args.value;
                                    });
                                    document.getElementsByName("stateName")[0].value = mappedRic[0].stateName;
                                    if (mappedRic[0].pricingAreaId != null) {
                                        document.getElementsByName("priceAreaName")[0].value = mappedRic[0].pricingAreaFullName;
                                    }
                                    else {
                                        document.getElementsByName("priceAreaName")[0].value = "";
                                    }
                                }
                                ).catch(
                                    response => {
                                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                        gridOptions.errorAlert("Error: " + message);
                                    }
                                );

                            },
                            placeholder: 'Identifier',
                            floatLabelType: 'Always'
                        });
                        ricObj.appendTo(ricElem);
                    }
                },
                periodIndicatorParams: {
                    create: () => {
                        periodIndicatorElem = document.createElement('input');
                        return periodIndicatorElem;
                    },
                    read: () => {
                        return periodIndicatorObj.value;
                    },
                    destroy: () => {
                        periodIndicatorObj.destroy();
                    },
                    write: (args) => {
                        var grid = document.getElementsByClassName("e-grid")[0]["ej2_instances"][0]; 
                        periodIndicatorObj = new DropDownList({
                            showClearButton: true,
                            allowFiltering: true,
                            dataSource: this.periods,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0])? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            change: (args) => {
                                periodSpanObj.enabled = true;
                                // select form element 
                               var column = this.$refs.grid.getColumnByField("periodSpan");                      
                                // add the validation rule if the value contains  'S' character else removing the validation rule 
                                if (args.isInteracted == true) {
                                    if (args.itemData.value != "Y") {                                   
                                        column.validationRules.required = true;
                                        periodSpanObj.enabled = true;
                                        periodSpanObj.placeholder = 'Select period'

                                    } else {
                                        column.validationRules.required = false;
                                        periodSpanObj.enabled = false;
                                        periodSpanObj.placeholder = ''
                                    
                                        if (document.getElementById("periodSpan_Error")) {
                                            document.getElementById("periodSpan_Error").remove(); // remove validation message when remove the rules 

                                        }
                                    }
                                }
                                let tempQuery = new Query().where('periodId', 'equal', periodIndicatorObj.value);
                                periodSpanObj.query = tempQuery;
                                periodSpanObj.text = null;
                                periodSpanObj.dataBind();
                            },
                            placeholder: 'Period Indicator',
                            floatLabelType: 'Always'
                        });

                        periodIndicatorObj.appendTo(periodIndicatorElem);
                    }
                },
                periodParams: {
                    create: () => {
                        periodParamElem = document.createElement('input');
                        return periodParamElem;
                    },
                    read: () => {
                        return periodSpanObj.value;
                    },
                    destroy: () => {
                        periodSpanObj.destroy();
                    },
                    write: function (args) {
                        periodSpanObj = new DropDownList({
                            showClearButton: true,
                            allowFiltering: true,
                            dataSource: SyncHelper.getDataManager('Utils/periodSpans'),
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            enabled: (args.foreignKeyData ? true : false),
                            placeholder: 'Period',
                            floatLabelType: 'Always',
                            query: new Query().where('periodId', 'equal', periodIndicatorObj.value)

                        });
                        periodSpanObj.appendTo(periodParamElem);
                    }
                },
                pageSettings: { pageSizes: [10, 20, 50, 100], pageSize: 100, pageCount: 4 },
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.LatestSettlement.Update"],
                    allowAdding: store.state.permissions["Permissions.LatestSettlement.Create"],
                    allowDeleting: store.state.permissions["Permissions.LatestSettlement.Delete"],
                    mode: 'Dialog'
                },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                percentageRules: { required: true, number: true},
                requiredRules: { required: false },
                periodSpanRequiredRules: { required: false },
                nameRules: { required: true, maxLength: 50},
                yearRules: { required: true, minLength: [(args) => { return args['value'].length == 4; }, 'Need 4 digits'] },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
            this.checkPermissionOnUser();
        },
        methods: {
            checkPermissionOnUser: function () {

                if (!this.$store.state.permissions["Permissions.MarketWidgetsAndGraphs.Update"]) {

                        this.toolbar = ['Add', 'Edit', 'Delete'];
                        document.getElementById("modalTarget").style.display = "none";
                    }
   
            },
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    this.$refs.grid.getColumns()[2].visible = false;
                    this.$refs.grid.getColumns()[3].visible = true;
                    this.$refs.grid.getColumns()[4].visible = false;
                    this.$refs.grid.getColumns()[5].visible = true;
                    this.$refs.grid.getColumns()[6].visible = false;
                    this.$refs.grid.getColumns()[7].visible = true;
                }
                gridOptions.excelExport(args, "Market Pricing.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.getColumns()[2].visible = true;
                this.$refs.grid.getColumns()[3].visible = false;
                this.$refs.grid.getColumns()[4].visible = true;
                this.$refs.grid.getColumns()[5].visible = false;
                this.$refs.grid.getColumns()[6].visible = true;
                this.$refs.grid.getColumns()[7].visible = false;
                this.$refs.grid.hideSpinner();
            },            
            actionBegin(args) {
                gridOptions.actionBegin(args);
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].field == "createdBy") {
                          this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "createdDate") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "date") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        }
                    }
                    this.$refs.grid.getColumns()[2].visible = true;
                    this.$refs.grid.getColumns()[3].visible = false;
                    this.$refs.grid.getColumns()[4].visible = true;
                    this.$refs.grid.getColumns()[5].visible = false;
                    this.$refs.grid.getColumns()[6].visible = true;
                    this.$refs.grid.getColumns()[7].visible = false;
                }
                if (args.requestType == 'save') {
                    showSpinner(document.getElementById('mainSpinner'));

                }
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));


                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
       
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].field == "createdBy") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "createdDate") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "date") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        }
                    }
                    this.$refs.grid.getColumns()[2].visible = false;
                    this.$refs.grid.getColumns()[3].visible = true;
                    this.$refs.grid.getColumns()[4].visible = false;
                    this.$refs.grid.getColumns()[5].visible = true;
                    this.$refs.grid.getColumns()[6].visible = false;
                    this.$refs.grid.getColumns()[7].visible = true;

                    document.getElementsByName("date")[0].value = this.dateVal.toISOString().split('T')[0];
                }
            },
            actionFailure(args) {
                gridOptions.actionFailure(args)
                hideSpinner(document.getElementById('mainSpinner'));
            },
            //onUploadSuccess: function (args) {
            //    this.$refs.grid.refresh();
            //},
            //onUploadFailed: function (args) {
            //    this.$refs.grid.refresh();
            //    var statusMessage = JSON.parse(args.e.currentTarget.response).message;
            //    args.statusText = statusMessage.trim();
            //},
            onUploadSuccess: function (args) {
                if (JSON.parse(args.e.currentTarget.response).status === "OK with Errors") {
                    let fileName = JSON.parse(args.e.currentTarget.response).file.fileDownloadName;
                    let base64String = JSON.parse(args.e.currentTarget.response).file.fileContents;
                    const byteCharacters = atob(base64String);
                    const byteNumbers = new Uint8Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const blob = new Blob([byteNumbers], { type: 'application/octet-stream' });
                    const url = window.URL.createObjectURL(blob);
                    const element = document.createElement('a');
                    element.href = url;
                    element.download = fileName;
                    document.body.appendChild(element);
                    element.click();
                    element.remove();
                    window.URL.revokeObjectURL(url);
                    var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                    args.statusText = statusMessage.trim();
                }
                this.$refs.grid.refresh();
            },
            onUploadFailed: function (args) {
                this.$refs.grid.refresh();
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
            },
            addHeaders: function (args) {
                args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
            },
            onFocus: function (args) {
                this.$refs.dateObj.show();
            },
        },
        computed: {
            query: function () {
          
                return new Query().addParams("date", this.dateVal.toISOString().split('T')[0]);

            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };
</script>
<style scoped>
    .market-price-padding {
        padding-top:30px;
       }
</style>
